import { FC } from 'react';

import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import TaskList from '../../modules/tasks/components/TaskList';
import { usePathProps } from '../../modules/user-profile/hooks/usePathProps';

const TasksComponent: FC = () => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <TaskList />
        </div>
      </div>
    </>
  );
};

const TasksPage: FC = () => {
  const intl = useIntl();
  usePathProps();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'menu.tasks' })}
      </PageTitle>
      <TasksComponent />
    </>
  );
};

export { TasksPage };
